var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-1 py-4 inverted--text"},[(_vm.icon)?_c('v-icon',{staticClass:"inverted--text"},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }